import './App.css';
import Footer from './Components/Footer';
import HeroSection from './Components/HeroSection';
import Skills from './Components/Skills';
import Portfolio from './Components/Portfolio';
import ContactUs from './Components/ContactUs';
import Navbar from './Components/Navbar';
import ThemeContext from './Context/ThemeContext';
import React,{useState} from 'react';
import "react-toastify/dist/ReactToastify.css";

import { ToastContainer } from 'react-toastify';
function App() {
  const themeHook=useState("light")

  return (
    <div>
      <ThemeContext.Provider value={themeHook}>
      <Navbar/>
      <HeroSection/>
      <Portfolio/>
      <Skills/>
      
      {/* <Experience/> */}
      <ToastContainer/>
          
      <ContactUs/>
      
      <Footer/>
      </ThemeContext.Provider>
    </div>
  );
}

export default App;
